module.exports = __webpack_public_path__ + "img/0.eea32b12.png";